import React from "react"
import styles from "./FeedbackFormHeader.module.scss"
import cn from "classnames"
import CloseButton from "../../../../CloseButton/CloseButton"
import { useAppDispatch } from "../../../../../store/hooks"
import { ReactComponent as FeedbackHeartIcon } from "../../../../../assets/images/icons/feedback-heart.svg"
import { actions } from "../../../../../store/dialogs/slice"
import { DIALOG_OPERATION_FEEDBACK_FORM_CONST } from "../../DialogOperatorFeedbackForm.const"

export type FeedbackFormHeaderProps = {
    text: string
    isError: boolean
}

const { testIds } = DIALOG_OPERATION_FEEDBACK_FORM_CONST

const FeedbackFormHeader = (props: FeedbackFormHeaderProps) => {
    const { text, isError } = props
    const dispatch = useAppDispatch()

    const handleClose = () => {
        dispatch(actions.setOperatorFeedbackFormState(false))
    }

    return (
        <div className={styles.header}>
            {!isError && <FeedbackHeartIcon className={styles.header__heartIcon} data-testid={testIds.heartIcon} />}
            <span className={cn(styles.header__text, isError && styles.header__headerText_error)}>{text}</span>
            <CloseButton
                className={styles.header__closeButton}
                size="2x"
                onClick={handleClose}
                testId={testIds.closeButton}
            />
        </div>
    )
}

export default FeedbackFormHeader
